import { useState, useEffect, useCallback } from 'react'

/**
 * Lightweight AnimatePresence replacement — manages mount/exit lifecycle
 * so CSS animations can play before the element is removed from the DOM.
 */
export function useAnimatePresence(show: boolean) {
  const [mounted, setMounted] = useState(show)
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    if (show) {
      setMounted(true)
      setExiting(false)
    } else if (mounted) {
      setExiting(true)
    }
  }, [show]) // eslint-disable-line react-hooks/exhaustive-deps

  const onAnimationEnd = useCallback(() => {
    if (exiting) {
      setMounted(false)
      setExiting(false)
    }
  }, [exiting])

  return { mounted, exiting, onAnimationEnd }
}
